import React from "react";
import Image from "next/image";
export default function Member({ data }) {
  return (
    <div className="flex lg:flex-row flex-col items-start justify-start md:gap-8 gap-4 w-full">
      <div className="relative lg:w-[300px] md:w-[250px] w-[300px] md:h-[200px] lg:h-[230px] h-[230px] rounded-xl overflow-hidden shrink-0">
        <Image
          src={data?.image}
          alt={data.name}
          fill
          className="object-cover object-[50%_20%] w-full"
          sizes="(max-width: 479px) 479px,(max-width: 768px) 479px, (max-width: 1200px) 479px,(max-width: 1920px) 479px, 479px "
        />
      </div>
      <div className="flex flex-col w-full gap-2">
        <p className="text-darkBlue font-bold md:text-xl text-base">
          {data?.name}
        </p>
        <div className="md:text-base text-sm text-justify">
          {data?.description}
        </div>
      </div>
    </div>
  );
}
